<template>
  <div id="searchWidget">
    <div class="row no-row-padding ">
      <div class="col map-wrapper" v-if="shouldShowMap" style="min-height: 50vh; max-width: 480px">
        <div class="d-flex justify-content-center align-items-center h-100" v-if="regions.length === 0">
          <Spinner></Spinner>
        </div>

        <ClickableMap v-else :regions.sync="regions"></ClickableMap>
      </div>
      <div class="col"  :style="compact ? null : 'max-width: 1000px;'">
        <div class="row">
          <template v-if="shouldShowMap">
            <div class="col-12">
              <div class="text-center">
                <h3 style="margin-top: 30px">
                  {{ $t("components.search.expanded.caption.title") }}
                </h3>
              </div>
              <p class="caption-text">
                {{ $t("components.search.expanded.caption.text") }}
              </p>
            </div>
            <div class="col-12">
              <hr class="solid" style="margin: 0" />
            </div>
          </template>
          <div :class="computeSizingClass()" class="regions-wrapper">
            <label class="col-form-label label"
              ><i class="fas fa-globe"></i>
              {{ $t("common.keywords.regions") }}</label
            ><br />

            <template v-if="shouldShowMap">
              <template v-if="selectedRegions.length > 0">
                <Pill
                  v-for="region in selectedRegions"
                  :key="region.id"
                  @dismissAction="removeSelection(region)"
                  >{{ region.localizedName | localized }}</Pill
                >
              </template>
              <label v-else class="col-form-label caption-region">{{
                $t("components.search.expanded.regions.noneSelected")
              }}</label>
            </template>
            <template v-else>
              <ModalToggleGroup :title="$t('common.keywords.regions')">
                <template v-slot:activator="{ on }">
                  <button
                    class="btn btn-secondary dropdown"
                    type="button"
                    v-on="on"
                  >
                    {{ computeRegionsButtonTitle }}
                  </button>
                </template>

                <template v-slot:content>
                  <RegionToggles :controls="false"></RegionToggles>
                </template>
              </ModalToggleGroup>
            </template>
          </div>
          <div :class="computeSizingClass()">
            <ModalDatePicker :selectedDates.sync="selectedDates" ref="calendar">
              <template v-slot:activator="{ on }">
                <label class="col-form-label label"
                  ><i class="fas fa-calendar-alt"></i>
                  {{ $t("common.reservation.travelDates") }}</label
                >
                <button
                  class="btn btn-secondary btn-block"
                  type="button"
                  v-on="on"
                >
                  {{ computeTravelDatesButtonTitle }}
                </button>
              </template>
            </ModalDatePicker>
          </div>
          <div :class="computeSizingClass()">
            <Modal>
              <template v-slot:header>
                <h3 style="margin-bottom: 0px">
                  {{ $t("common.generalities.occupants") }}
                </h3>
              </template>

              <template v-slot:content>
                <OccupantsStepper :controls="false"></OccupantsStepper>
              </template>

              <template v-slot:activator="{ on }">
                <label class="col-form-label label"
                  ><i class="fas fa-users"></i>
                  {{ $t("common.generalities.occupants") }}</label
                >
                <button
                  class="btn btn-secondary btn-block"
                  type="button"
                  v-on="on"
                >
                  {{ computeTravelersPlaceholder }}
                </button>
              </template>
            </Modal>
          </div>
          <div :class="computeSizingClass()">
            <ModalToggleGroup :title="$t('common.keywords.properties')">
              <template v-slot:activator="{ on }">
                <label class="col-form-label label"
                  ><i class="fas fa-cog"></i>
                  {{ $t("common.keywords.properties") }}</label
                >
                <button
                  class="btn btn-secondary btn-block"
                  type="button"
                  v-on="on"
                  v-html="computePropertiesButtonTitle"
                ></button>
              </template>

              <template v-slot:content>
                <PropertiesToggles :controls="false"></PropertiesToggles>
              </template>
            </ModalToggleGroup>
          </div>
          <div :class="computeSizingClass()">
            <ModalToggleGroup :title="$t('common.keywords.houseTypes')">
              <template v-slot:activator="{ on }">
                <label class="col-form-label label"
                  ><i class="fas fa-home"></i>
                  {{ $t("common.keywords.houseTypes") }}</label
                ><br />
                <button
                  class="btn btn-secondary btn-block"
                  type="button"
                  v-on="on"
                >
                  {{ computeHouseTypesButtonTitle }}
                </button>
              </template>

              <template v-slot:content>
                <HouseTypesToggles :controls="false"></HouseTypesToggles>
              </template>
            </ModalToggleGroup>
          </div>
          <div :class="computeSizingClass()" v-if="compact">
            <label class="col-form-label" style="visibility: hidden"
              >Filler</label
            ><br />
            <button
              class="btn btn-outline-primary btn-block btn-search"
              id="searchButton"
              type="button"
              @click="search"
            >
              <i class="fas fa-search"></i>
              {{ $t("components.search.common.search") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!compact">
      <div class="row">
        <div class="col-12">
          <hr class="solid" />
        </div>
      </div>

      <div class="row no-row-padding">
        <div
          class="col-12 d-flex justify-content-center justify-content-sm-end"
        >
          <button
            class="btn btn-outline-primary btn-block search actionButton btn-search"
            id="searchButton"
            type="button"
            @click="search"
          >
            <i class="fas fa-search"></i>
            {{ $t("components.search.common.search") }}
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
// import ClickableMap from "@/components/level2/ClickableMap"
import ClickableMap from "@/components/level2/ClickableMap";
import Pill from "@/components/common/Pill";
import ModalDatePicker from "@/components/common/datepicker/ModalDatePicker";
import OccupantsPicker from "@/components/common/OccupantsPicker";
import Modal from "@/components/common/Modal";
import Spinner from "@/components/common/Spinner";
import ModalToggleGroup from "@/components/common/ModalToggleGroup";
import HouseTypesToggles from "@/components/search/HouseTypesToggles";
import RegionToggles from "@/components/search/RegionToggles";
import OccupantsStepper from "@/components/search/OccupantsStepper";
import PropertiesToggles from "@/components/search/PropertiesToggles";

export default {
  name: "SearchWidget",
  components: {
    OccupantsPicker,
    ClickableMap,
    Pill,
    Modal,
    ModalDatePicker,
    ModalToggleGroup,
    Spinner,
    HouseTypesToggles,
    RegionToggles,
    OccupantsStepper,
    PropertiesToggles,
  },
  props: {
    showMap: {
      type: Boolean,
      required: false,
      default: true,
    },
    compact: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    search: function () {
      // Save the query
      this.$store.commit("setQuery", this.query);

      if (!this.$route.path.includes("search")) {
        this.$router.push("/search");
      }

      this.$emit("search");
    },
    computeText: function (value, str) {
      if (value == 0) {
        return "";
      }

      return value + " " + str;
    },
    computeSizingClass: function () {
      if (this.shouldShowMap) {
        return `col-6 col-md-12`;
      }
      return `col-xl-2 col-lg-4 col-md-4 col-sm-6`;
    },
    removeSelection: function (region) {
      let found = this.regions.find((el) => el === region);
      this.$set(found, "value", false);
    },
  },
  computed: {
    query: function () {
      return this.$store.getters.getQuery;
    },
    houseTypes: function () {
      return this.$store.getters.getHouseTypes || [];
    },
    regions: function () {
      return this.$store.getters.getRegions || [];
    },
    properties: function () {
      return this.$store.getters.getProperties;
    },

    computeHouseTypesButtonTitle: function () {
      let selected = this.houseTypes.filter((el) => el.value);

      if (this.houseTypes.length === selected.length) {
        return `${this.$i18n.t("common.generic.all")} ${this.$i18n.t(
          "common.generic.selected"
        )}`;
      } else if (selected.length > 0) {
        return `${selected.length} ${this.$i18n.t("common.generic.selected")}`;
      }
      return this.$i18n.t("common.placeholders.clickToSelect");
    },
    computePropertiesButtonTitle: function () {
      let props = this.properties.filter((el) => el.value);

      if (props.length === 0) {
        return this.$i18n.t("common.placeholders.clickToSelect");
      }

      return props
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((el) => el.icon)
        .map((el) => `<i class="${el}"></i>`)
        .join(" - ");
    },
    computeRegionsButtonTitle: function () {
      let selected = this.selectedRegions;

      if (this.regions.length === selected.length) {
        return `${this.$i18n.t("common.generic.all")} ${this.$i18n.t(
          "common.generic.selected"
        )}`;
      } else if (selected.length > 0) {
        return `${selected.length} ${this.$i18n.t("common.generic.selected")}`;
      }
      return this.$i18n.t("common.placeholders.clickToSelect");
    },
    shouldShowMap: function () {
      if (this.$isMobile()) {
        return false;
      }

      return this.showMap;
    },
    computeTravelDatesButtonTitle: function () {
      if (
        this.isUndefined(this.query.selectedDates) ||
        this.allFieldsAreUndefined(this.query.selectedDates)
      ) {
        return this.$i18n.t("common.placeholders.clickToSelect");
      }

      let startDate = this.$moment(this.query.selectedDates.start);
      let endDate = this.$moment(this.query.selectedDates.end);

      let format = startDate.year() === endDate.year() ? "DD.MM" : "DD.MM.YYYY";

      return startDate.format(format) + " - " + endDate.format(format);
    },
    computeTravelersPlaceholder: function () {
      let comp = [
        this.computeText(
          this.query.numberOfAdults,
          this.$i18n.tc("common.generic.adult", this.query.numberOfAdults)
        ),
        this.computeText(
          this.query.numberOfKids,
          this.$i18n.tc("common.generic.kid", this.query.numberOfKids)
        ),
      ]
        .filter((val) => val !== "")
        .join(", ");

      if (comp.trim() === "") {
        return this.$i18n.t("common.placeholders.clickToSelect");
      }

      return comp;
    },
    computeAdvancedOptionsButtonTitle: function () {
      if (isMobile) {
        return "Options";
      }

      return (this.isCollapseOpen ? "Hide" : "Show") + " Advanced Options";
    },
    computeAdvancedOptionsButtonIcon: function () {
      return "fas fa-" + (this.isCollapseOpen ? "minus" : "plus") + "-circle";
    },
    defaultSearch: {
      get() {
        let query = this.$store.getters.getQuery;
        if (query.location !== undefined) {
          return this.$options.filters.localized(query.location.localizedName);
        } else {
          return undefined;
        }
      },
    },
    selectedDates: {
      get() {
        return this.query.selectedDates;
      },
      set(val) {
        console.log(val);
        // this.query.selectedDates = val;
        let query = this.query;
        query.selectedDates = val;
        this.$store.commit("setQuery", query);
      },
    },
    selectedRegions: function () {
      if (this.regions === undefined) {
        return [];
      }
      return this.regions
        .filter((el) => el.value)
        .sort((a, b) => (a.sequence < b.sequence ? -1 : 1));
    },
  },
};
</script>

<style lang="scss" scoped>
#searchWidget {
  overflow: hidden;
  background-color: $white;
  padding: 16px;
  width: 100%;
  border-radius: 15px;
}

h3 {
  font-family: 'Noto Serif SC', serif;
  font-weight: 300;
  line-height: 1.3;
  letter-spacing: 0.02em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

.form-control {
  padding: 0px !important;
  border: none;
}

.propertiesContainer {
  margin-bottom: 24px;
}

.dropdown {
  width: 100%;
  border-radius: $border-radius !important;
}

p {
  font-family: 'Noto Serif', serif;
}

.badge.badge-secondary {
  font-family:system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: 300;
}

.btn {
  border-radius: $border-radius;
}

.btn-outline-primary {
  background-color: transparent !important;
  border-color: $primary-color !important;
  color: $primary-color !important;
}
.btn-outline-primary.active.show {
  background-color: $primary-color !important;
  color: white !important;
}

.nav-link.active.show {
  background-color: white;
  color: $primary-color !important;
  font-weight: bold;
  border-radius: $border-radius;
}

.no-top-margin {
  margin-top: 0px;
}

.caption-text {
  margin-bottom: 8px; 
  color: #1d2127; 
  font-family: "Open Sans", sans-serif;

}

.caption-region {
  font-family: 'Open Sans', sans-serif;
}

.label {
  margin-top: 5px;
  font-family: 'Museo Sans', sans-serif;
}

@media (max-width: 575.98px) {
  .actionButton {
    width: 100%;
  }
}


@media (max-width: 650px) {
  .map-wrapper {
    min-width: 380px;
    max-height: min(calc(100vh - 80px));
  }
}

@media (max-width: 410px) {
  .map-wrapper {
    
    min-width: 280px;
  }
}


@media (max-width: 768px){
  #searchWidget .regions-wrapper {
    align-self: stretch;
    flex: auto;
    max-width: 100%;

  }
}


.btn-search {
  border-width: 1px;
}

#searchWidget::-webkit-scrollbar-track {
  border-radius: 2px;
  background-color: $white-01;
}

#searchWidget::-webkit-scrollbar {
  width: 10px;
  background-color: $white-01;
}

#searchWidget::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background-color: $primary-color;
}
</style>
